import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import * as css from './Breadcrumbs.scss';

class Breadcrumbs extends React.Component {
  static propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
    breadcrumbsLabel: PropTypes.string.isRequired,
    isPositive: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isPositive: true,
  };

  state = { itemsVisible: false, showMiddle: false };

  showCrumbs = () => {
    this.setState({ showMiddle: true }, () => {
      requestAnimationFrame(() => {
        this.setState({ itemsVisible: true });
      });

      window.addEventListener('scroll', this.hideCrumbs);
      window.addEventListener('resize', this.hideCrumbs);
    });
  };

  hideCrumbs = () => {
    this.setState({ itemsVisible: false, showMiddle: false }, () => {
      window.removeEventListener('scroll', this.hideCrumbs);
      window.removeEventListener('resize', this.hideCrumbs);
    });
  };

  handleTransitionEnd = () => {
    if (!this.state.itemsVisible) {
      this.setState({ showMiddle: false });
    }
  };

  render() {
    const { breadcrumbs, breadcrumbsLabel, isPositive } = this.props;
    const { itemsVisible, showMiddle } = this.state;

    return (
      <nav
        className={cn(css.breadcrumbs, { [css.positive]: isPositive })}
        itemProp="breadcrumb"
        itemScope
        itemType="http://schema.org/BreadcrumbList"
        aria-label={breadcrumbsLabel}
      >
        <ol ref={node => (this.list = node)}>
          {breadcrumbs && breadcrumbs.length > 2 && !itemsVisible && (
            <li ref={node => (this.toggler = node)}>
              <a onClick={this.showCrumbs} role="button">
                ...
              </a>
              <span
                aria-hidden="true"
                className={css['breadcrumbs__separator']}
              >
                /
              </span>
            </li>
          )}

          {breadcrumbs.map((b, i) => {
            const isMiddle = i >= 1 && i < breadcrumbs.length - 1;
            const shouldShow = !isMiddle || showMiddle;

            return (
              <li
                key={i}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
                className={cn({
                  [css.breadcrumbItem]: shouldShow,
                  [css.breadcrumbItemHidden]: isMiddle && !itemsVisible,
                })}
                style={{
                  display: shouldShow ? 'block' : 'none',
                }}
                onTransitionEnd={this.handleTransitionEnd}
              >
                {i !== 0 && (
                  <span
                    aria-hidden="true"
                    className={css['breadcrumbs__separator']}
                  >
                    /
                  </span>
                )}
                <a
                  href={b.url}
                  itemProp="item"
                  className={css['breadcrumbs__link']}
                >
                  {b.title}
                </a>
                <meta itemProp="position" content={i} />
                <meta itemProp="name" content={b.title} />
              </li>
            );
          })}
        </ol>
      </nav>
    );
  }
}

export default Breadcrumbs;
